import React from "react";
import PropTypes from "prop-types";
import { Card } from "cxa-components";
import { ClientLogo } from "@cxagroup/casper";
import LogoPP from "../common/LogoPP";
import GlobalMessageBoard from "../common/global-message-board";

const AuthLayout = ({ client, logoUrl, pageName, children }) => {
  return (
    <div>
      <div
        style={{
          backgroundColor: "pink",
          position: "sticky",
          left: "0",
          top: "0",
          zIndex: "100",
        }}
      >
        <GlobalMessageBoard />
      </div>
      <div className="login-wrapper">
        <Card>
          <header>
            {logoUrl ? (
              <ClientLogo client={client} logoUrl={logoUrl} size="large" />
            ) : (
              <LogoPP width={240} />
            )}
            <h3>{pageName}</h3>
          </header>
          {children}
        </Card>
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  logoUrl: PropTypes.string,
  pageName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default AuthLayout;



// WEBPACK FOOTER //
// ./components/common/AuthLayout.jsx